import React from 'react'
import SvgIcon from 'rambler-ui/icons/SvgIcon'

export default function MotorLogo ({width, height}) {
  return (
    <SvgIcon
      color='currentColor'
      style={{
        width: width,
        height: height
      }}
      viewBox='0 0 115 50'>
      <g fill='none' fillRule='evenodd'>
        <path
          fill='#000'
          d='M93.401 19.635V17.42h-3.939v16.018h4.297v-9c0-1.92 1.045-3.123 3.182-3.123l2.166-.01c.002 0 .017-4.245.017-4.245h-1.608c-2.053 0-3.399.762-4.115 2.575zM80.115 29.834c-2.38 0-4.174-1.889-4.174-4.393 0-2.157 1.464-4.449 4.174-4.449 2.712 0 4.176 2.292 4.176 4.449 0 2.504-1.795 4.393-4.176 4.393zm0-13.008c-4.773 0-8.513 3.784-8.513 8.615 0 4.799 3.74 8.559 8.514 8.559 4.774 0 8.514-3.76 8.514-8.559 0-4.83-3.74-8.615-8.514-8.615zM67.977 27.238v-6.039h3.581v-3.78h-3.58V14H63.5v14.773c0 3.444 1.728 4.665 4.346 4.665h3.862v-4.28l-2.168.016c-1.266 0-1.564-.62-1.564-1.936zM38.58 16.826c-2.285 0-4.18.992-5.387 3.084-.838-1.994-2.47-3.084-4.757-3.084-1.78 0-3.48.776-4.563 2.492-.34-1.939-1.56-2.438-3.375-2.438h-4.497L16 21.154l2.407-.017c.862 0 1.409.436 1.409 1.28v11.021h4.297v-9.267c0-1.56.923-3.111 3.138-3.111 1.963 0 2.949 1.196 2.949 3.113v9.265h4.296v-9.265c0-1.842 1.275-3.18 3.112-3.18 2.017 0 2.976 1.213 2.976 3.18v9.265h4.297v-9.746c0-4.617-2.298-6.866-6.301-6.866zM54.18 29.834c-2.38 0-4.175-1.889-4.175-4.393 0-2.157 1.463-4.449 4.175-4.449 2.711 0 4.174 2.292 4.174 4.449 0 2.504-1.794 4.393-4.174 4.393zm0-13.008c-4.774 0-8.514 3.784-8.514 8.615 0 4.799 3.74 8.559 8.514 8.559 4.774 0 8.514-3.76 8.514-8.559 0-4.83-3.74-8.615-8.514-8.615zM115 0v50V0zM0 0v50V0z'
        />
      </g>
    </SvgIcon>
  )
}
